import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

type CityInputProps = FieldControllerProps<'city', string | null> & ClassNameProp;

export const CityInput = (props: CityInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 50,
   });

   return (
      <TextInput
         testId={props.name}
         label={commonTranslationKeys.addressData.town}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
